import { useLocation } from 'react-router-dom';

export function useCurrentProjectId() {
    const locationSuffix = useLocation().pathname.split('/').pop();
    if (locationSuffix && locationSuffix.startsWith('prj_')) {
        return locationSuffix;
    }
    return '';
}
